export default "__VITE_ASSET__BM$bE1jW__"